<template>
<div class="swiperCarrousel SwiperOccupations" :class="{'swiperObj':$store.state.innerWidth>=815}">
    <div class="swiperContent" ref="content">
        <swiper :options="swiperOption " v-if="showSwiper" :class="{'padding-30':showBtn}" class="swiperCarrousel SwiperArticles">
            <swiper-slide 
                class="swiper-slide box-slide occupations" 
                :class="{'swiper-no-swiping':!canSwiper}" 
                v-if="index<5" 
                v-for="(item,index) in data"

            >
                <div class="g-group pointer" @click="goToDetail(item)">
                    <img v-bind:src="item.imageCode" :alt="$store.getters.getObject(item.langMap).title"/>
                    <div class="title Bold wrap">
                        <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(item.langMap).title}}</a>
                    </div>
                </div>
             
            </swiper-slide>
          
        </swiper>
        <div class="swiper-button-prev" v-if="showBtn" slot="button-prev">
            <i class="icon-arrow-down"></i>
        </div>
        <div class="swiper-button-next" v-if="showBtn" slot="button-next">
            <i class="icon-arrow-down"></i>
        </div>
    </div>
</div>
</template>
<script>

import Swiper from 'swiper';
export default {
    data() {
        return {
            totalRows: 0,
            showBtn:true,
            canSwiper:true,
            showSwiper:false,
            swiperOption: {
                autoHeight: true, 
                slidesPerView: 2.2,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        }
    },
    watch:{
        innerwidth (news,old) {
            this.showSwiper = false;
            this.setWidth()
        },
        data: function(n, o) {
            this.setWidth()
        },
     },
    props: {
        data:{},
        init:null,
        callback:null,
        courseList:null,
        childLogGaEvent:null
    },
    methods: {
        goToDetail:function(item){
            
            if(this.$store.state.isPreview) return;
            this.childLogGaEvent('userClick','related occupationDetail',item.id)
            this.$router.push({ path: "/occupationDetails/" + item.id, query:{
                    "lang":this.$store.state.language,
                    "name":this.$store.getters.replaceEvent(this.$store.getters.getObject(item.langMap).title)
                } 
            });
            // this.init();
        },
        setWidth:function(){
            var that = this;
            this.$refs.content.style.width= '100%'
            if(this.$store.state.innerWidth>=1345){
                this.showBtn = false;
                this.canSwiper = false;
                // this.$refs.content.style.width= '100%'
            }else if(this.$store.state.innerWidth >= 1080){
                this.showBtn = true;
                this.canSwiper = false;
                // this.$refs.content.style.width= 1118 + 'px'
            }else if(this.$store.state.innerWidth >= 815){
                this.showBtn = true;
                this.canSwiper = false;
                // this.$refs.content.style.width= 855 + 'px'
            }else{
                this.showBtn = false;
                this.canSwiper = true;
                this.$refs.content.style.width= '100%'
            }
            if(this.$store.state.innerWidth>=1345){
                this.swiperOption = {
                    slidesPerView: 5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth >= 1080){
                var space = (this.$store.state.innerWidth - 85 -(250)*4)/3;
                this.swiperOption = {
                    slidesPerView: 4,
                    spaceBetween: space,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth >= 815){
                var space = (this.$store.state.innerWidth - 85 -(250)*3)/2;
                this.swiperOption = {
                    slidesPerView: 3,
                    spaceBetween: space,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth>768){
                this.swiperOption = {
                    slidesPerView: 3,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth>650){
                this.swiperOption = {
                    slidesPerView: 2.9,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(this.$store.state.innerWidth>550){
                this.swiperOption = {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else{
                this.swiperOption = {
                    slidesPerView: 2.2,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
            
                this.showSwiper = false;
                this.$nextTick(() => {
                    this.showSwiper = true
                });
        }
    },
    mounted() {
        // this.mySwiper = new Swiper('.swiper-container')
        this.setWidth();
        var that = this;
        setTimeout(function(){
            that.setWidth();
        },1000)
    }
}
</script>